import { render, staticRenderFns } from "./OtherTooltip.vue?vue&type=template&id=3dadd4e3&scoped=true"
import script from "./OtherTooltip.vue?vue&type=script&lang=js"
export * from "./OtherTooltip.vue?vue&type=script&lang=js"
import style0 from "./OtherTooltip.vue?vue&type=style&index=0&id=3dadd4e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dadd4e3",
  null
  
)

export default component.exports